import { render, staticRenderFns } from "./Maestra.vue?vue&type=template&id=f201262e"
import script from "./Maestra.vue?vue&type=script&lang=js"
export * from "./Maestra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports